import { BaseModel } from "../base.model";

enum HighlightState {
  lyAdverb = "lyAdverb",
  strongVerb = "strongVerb",
  qualityAdjective = "qualityAdjective",
}

type WordListConstructorParams = {
  id: string;
  label: string;
  words: string[];
  isReadOnly?: boolean;
  bannedWords: { [key: string]: string[] };
  highlightStates: { [key: string]: HighlightState };
};

export class WordList extends BaseModel {
  id: string;
  label: string;
  words: string[];
  isReadOnly: boolean;
  bannedWords: { [key: string]: string[] };
  highlightStates: { [key: string]: HighlightState };

  constructor(data: WordListConstructorParams) {
    super(data);
    this.id = data.id;
    this.label = data.label;
    this.words = data.words;
    this.isReadOnly = data.isReadOnly ?? false;
    this.bannedWords = data.bannedWords;
    this.highlightStates = data.highlightStates;
  }

  override get databaseConfig() {
    return {
      collection: "wordLists",
      path: `/wordLists/${this.id}`,
    };
  }

  static override fromMap(map: any) {
    return new WordList(map);
  }
}
